export default __webpack_public_path__ + "96d24f37661fb3cd839a8d443584c499.jpg";